import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BaseService } from '../../core';
import { environment } from 'environments/environment';

export interface ParametrosSistemaResponse {
  diasToleranciaInadimplencia: number;
  cadenciaEmailsInadimplencia: string; // CSV "0,7,14"
}

export interface AtualizarParametrosSistemaRequest {
  diasToleranciaInadimplencia: number;
  cadenciaEmailsInadimplencia: string;
}

export interface PlanoParametroResponse {
  id: number;
  nome: string;
  quantidadeUsuario: number; // 0 = ilimitado
  preco: number;
}

export interface AtualizarPlanoParametroRequest {
  nome: string;
  quantidadeUsuario: number;
  preco: number;
}

@Injectable({ providedIn: 'root' })
export class ParametroService extends BaseService {
  private endpoint = environment.urlEdducaImobApi.concat('api/Parametro/');

  constructor(private http: HttpClient) {
    super();
  }

  getSistema(loader = true): Observable<ParametrosSistemaResponse> {
    return this.http.get<ParametrosSistemaResponse>(
      this.endpoint.concat('Sistema'),
      { headers: this.getHeader(loader) }
    );
  }

  atualizarSistema(request: AtualizarParametrosSistemaRequest, loader = true): Observable<{ message: string }> {
    return this.http.put<{ message: string }>(
      this.endpoint.concat('Sistema'),
      request,
      { headers: this.getHeader(loader) }
    );
  }

  getPlanos(loader = true): Observable<PlanoParametroResponse[]> {
    return this.http.get<PlanoParametroResponse[]>(
      this.endpoint.concat('Planos'),
      { headers: this.getHeader(loader) }
    );
  }

  atualizarPlano(id: number, request: AtualizarPlanoParametroRequest, loader = true): Observable<{ message: string }> {
    return this.http.put<{ message: string }>(
      this.endpoint.concat('Planos/').concat(String(id)),
      request,
      { headers: this.getHeader(loader) }
    );
  }
}
